import React from "react";
import { Modal } from "react-bootstrap";
import { Picker } from "../../common/inputs";
import { FormGroup } from "../../common/containers/formContainer";

function AdditionalFiltersModal({
  show,
  onHide,
  onApply,
  onReset,
  additionalFilter,
  handleUpdateFilter,
  teamMembers,
  owner,
  category,
  constants,
}) {
  const newsletterOptions = [
    { label: "All", value: null },
    { label: "Subscribed", value: "1" },
    { label: "Not Subscribed", value: "0" },
  ];

  const priorityOptions = [
    { label: "All", value: null },
    { label: "Hot", value: "hot" },
    { label: "Warm", value: "warm" },
    { label: "Cold", value: "cold" },
    { label: "Expired", value: "expired" },
  ];

  const statusOptions = [
    { label: "All", value: null },
    { label: "Active", value: "active" },
    { label: "Inactive", value: "inactive" },
  ];
  

  const selectedNewsletter =
    additionalFilter.newsletter !== null
      ? newsletterOptions.find(
          (item) => item.value === additionalFilter.newsletter
        )
      : newsletterOptions[0];

  const selectedManagedBy =
    additionalFilter.managedBy !== null
      ? teamMembers.find((item) => item.value === additionalFilter.managedBy)
      : { label: "All", value: null };

  const selectedPriority =
    priorityOptions.find(
      (item) => item.value === additionalFilter.priority
    ) || priorityOptions[0];   

  const selectedStatus =
    priorityOptions.find(
      (item) => item.value === additionalFilter.status
    ) || statusOptions[0];   

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <h4 className="modal-title">Apply Filters</h4>
      </Modal.Header>

      <Modal.Body>
        {((category !== constants.CATEGORY.INTL_OFFICE &&
          category !== constants.CATEGORY.COUNTRY_OFFICE) ||
          owner) && (
          <FormGroup
            type="horizontal"
            label="Managed By"
            input={
              <Picker
                items={[{ label: "All", value: null }, ...teamMembers]}
                selectedItem={selectedManagedBy}
                onSelectItem={(option) =>
                  handleUpdateFilter("managedBy", option.value)
                }
              />
            }
          />
        )}

        <FormGroup
          type="horizontal"
          label="Newsletter"
          input={
            <Picker
              items={newsletterOptions}
              selectedItem={selectedNewsletter}
              onSelectItem={(option) =>
                handleUpdateFilter("newsletter", option.value)
              }
            />
          }
        />

        <FormGroup
            type="horizontal"
            label="Priority"
            input={
                <Picker
                items={priorityOptions}
                selectedItem={selectedPriority}
                onSelectItem={(option) =>
                    handleUpdateFilter("priority", option.value)
                }
                />
            }
            />

         <FormGroup
            type="horizontal"
            label="Status"
            input={
                <Picker
                items={statusOptions}
                selectedItem={selectedStatus}
                onSelectItem={(option) =>
                    handleUpdateFilter("status", option.value)
                }
                />
            }
            />    
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={onReset}
        >
          Reset Filter
        </button>

        <button
          type="button"
          className="btn btn-primary ml-2"
          onClick={onApply}
        >
          Apply Filters
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default AdditionalFiltersModal;